import _ from "lodash";

export class Query {
    constructor({ url, transport, data = {} }) {
        this._url = url;
        this._transport = transport;
        this._data = data;
        this.beforeTransform = function(data) {
            return data;
        };
        this.afterTransform = function(data) {
            return data;
        };
    }

    exec() {
        let data = this.beforeTransform.call(this, this._data);
        return this._transport.fetch(this._url, data)
            .then( (data, status, xhr) => {
                let response = this.afterTransform.call(this, data);
                return data
			});
    }
}
